import Vue from 'vue';

Vue.directive('resize', {
  bind(el, binding) {
    let width = '', height = '';
    function get() {
      if (width !== el.clientWidth || height !== el.clientHeight) {
        width = el.clientWidth;
        height = el.clientHeight;
        let change = setTimeout(() => {
          if (width === el.clientWidth || height === el.clientHeight) {
            binding.value({ width, height });
          }
          clearTimeout(change);
        }, 50);
      }
      width = el.clientWidth;
      height = el.clientHeight;
    }
    el.__vueReize__ = setInterval(get, 200);
  },
  unbind(el) {
    clearInterval(el.__vueReize__);
  },
});